import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommFilterJunctionOutFormTable extends Layout {
    sourceMCFilterJunctionOutForm: DataSource;
    tableMCFilterJunctionOutForm: Table;
}
